import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_94: FaireProductEntity = {
  token: "legacy_prod_abbott-94",
  type: "product",
  name: "Large Velvet Pouch with 3D Heart, Dark Grey 5×7 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/5230306d4216bdfb1cb1d2e4bf30abf07e88d21b6df0b8b77f416318498bacff.jpeg",
  priceDollars: 14,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
